/**
 * all states from store
 */
export default {
    categories: {},
}